import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import {
  Container,
  Label
} from '../../../styles/global'

import {
  ForgotPasswordContainer,
  ContainerEmail,
  InputPassword,
  InputEmail,
  ButtonSend,
  PasswordHint,
  ContainerPassword,
  PasswordHintSpan, PasswordCheck
} from './styles'
import { saveNewPassword } from '../../../services/professionals'
import {
  AT_LEAST_ONE_CAPITAL_LETTER,
  AT_LEAST_ONE_LOWER_LETTER,
  AT_LEAST_ONE_NUMERAL,
  MIN_LENGTH_8
} from '../../../utils/constants'

const CreatePasswordView = () => {
  const history = useHistory()
  const query = new URLSearchParams(useLocation().search)
  const professionalId = query.get('professional-id')
  const email = query.get('email')
  const [password, setPassword] = useState('')
  const [passwordValidator, setPasswordValidator] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSaveNewPassword = async () => {
    setLoading(true)
    if (!isPasswordValid()) {
      setLoading(false)
      return
    }

    const status = await saveNewPassword(professionalId, password)

    if (status === 200) {
      localStorage.removeItem('userData')
      history.push('/login')
    }
    setLoading(false)
  }

  const handlePasswordValidation = async (e) => {
    const password = e.target.value
    setPasswordValidator({
      isMinLengthValid: MIN_LENGTH_8.test(password),
      hasAtLeastOneCapitalLetter: AT_LEAST_ONE_CAPITAL_LETTER.test(password),
      hasAtLeastOneLowerLetter: AT_LEAST_ONE_LOWER_LETTER.test(password),
      hasAtLeastOneNumber: AT_LEAST_ONE_NUMERAL.test(password)
    })

    setPassword(password)
  }

  const isPasswordValid = () => {
    const isMinLengthValid = passwordValidator.isMinLengthValid
    const hasAtLeastOneCapitalLetter = passwordValidator.hasAtLeastOneCapitalLetter
    const hasAtLeastOneLowerLetter = passwordValidator.hasAtLeastOneLowerLetter
    const hasAtLeastOneNumber = passwordValidator.hasAtLeastOneNumber

    return isMinLengthValid && hasAtLeastOneCapitalLetter && hasAtLeastOneLowerLetter &&
      hasAtLeastOneNumber
  }

  return (
    <Container>
      <ForgotPasswordContainer>
        <div>
          <h2>Criar Senha</h2>
        </div>
        <ContainerEmail>
          <Label>E-mail</Label>
          <InputEmail value={email} disabled={true} />
        </ContainerEmail>
        <ContainerPassword>
          <Label>Senha</Label>
          <InputPassword onChange={handlePasswordValidation} type='password' />
          <PasswordHint>
            <PasswordHintSpan className="font-weight-bold">A senha deve conter: </PasswordHintSpan>
            <PasswordHintSpan className={`${passwordValidator.hasAtLeastOneCapitalLetter ? '' : 'is-not-valid'}`}>
              <PasswordCheck className={`${passwordValidator.hasAtLeastOneCapitalLetter ? 'check' : 'not-check'}`} /> Letras maiúsculas;
            </PasswordHintSpan>
            <PasswordHintSpan className={`${passwordValidator.hasAtLeastOneLowerLetter ? '' : 'is-not-valid'}`}>
              <PasswordCheck className={`${passwordValidator.hasAtLeastOneLowerLetter ? 'check' : 'not-check'}`} /> Letras minúsculas;
            </PasswordHintSpan>
            <PasswordHintSpan className={`${passwordValidator.hasAtLeastOneNumber ? '' : 'is-not-valid'}`}>
              <PasswordCheck className={`${passwordValidator.hasAtLeastOneNumber ? 'check' : 'not-check'}`} /> Número;
            </PasswordHintSpan>
            <PasswordHintSpan className={`${passwordValidator.isMinLengthValid ? '' : 'is-not-valid'}`}>
              <PasswordCheck className={`${passwordValidator.isMinLengthValid ? 'check' : 'not-check'}`} /> Tamanho mínimo de 8 caracteres.
            </PasswordHintSpan>
          </PasswordHint>
        </ContainerPassword>
        <ButtonSend onClick={handleSaveNewPassword} disabled={loading}>
          Enviar
        </ButtonSend>
      </ForgotPasswordContainer>
    </Container>
  )
}

export default CreatePasswordView
